<template>
	<div style="display: flex;flex-direction: row;margin:31px 0px 20px 40px">
		<div class="vehicle_tree" style="display: flex;flex-direction: column;">
			<div style="display: inline-block;vertical-align: middle;">
				<span style="font-size: 14px;font-weight: bold;">{{$t('carlineBinding.carlineBind')}}</span>
				<i class="iconfont icon-icon_prompt2" style="margin-left: 20px;color: #FF8C00;font-size: 12px;"></i>
				<span style="font-size: 12px;color:#FF8C00;margin-left: 6px;">{{$t('carlineBinding.clickBind')}}</span>
			</div>
			<div class="bindclass">
				<div class="carlist">
					<div style="font-weight: bold;margin:20px 0px 0px 30px;
font-size: 12px;">{{$t('carlineBinding.vehiclelist')}}</div>
					<el-input v-model="searchinput" :placeholder="$t('public.vehicleInputTips')" size="small" clearable
						style="margin: 16px 30px;width: 300px;">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
					<div style="margin-left: 30px;	overflow:auto;
		height:400px;">
						<el-tree id="el-tree" ref="tree" default-expand-all style="background-color: transparent;"
							node-key="id" show-checkbox :data="data" @check-change="handleCheckChange">
							<span slot-scope="{ node, data }">

								<span v-if="data.treeLevel !=5"
									class="tree_folder">{{ data.name }}({{ calcTreeCount(data)}}/{{data.totalCount }})</span>
								<span v-else class="tree_file">
									<i class="iconfont icon-icon_bus_list"></i>
									{{ data.name}}</span>
							</span>
						</el-tree>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;    justify-content: center;
    align-items: Center;margin: 280px 20px">
					<el-button size="mini" style="width: 64px;" type="primary"
						@click="bindvehicle">{{$t('carlineBinding.bind')}}</el-button>
					<span style="font-size: 12px;margin-top: 30px;" v-if="bindstate">
						<i class="el-icon-success"></i>
						{{$t('carlineBinding.bindsuccess')}}
					</span>
				</div>
				<div class="routeclass">
					<div style="font-weight: bold;margin:20px 0px 0px 30px;
			font-size: 12px;">{{$t('carlineBinding.organstructure')}}</div>
					<div style="margin-left: 30px;margin-top: 20px;	overflow-y: scroll;
		overflow: auto;height:400px;">
						<el-tree id="el-tree" ref="dataTree" default-expand-all style="background-color: transparent;"
							:props="organProps" show-checkbox :data="organdata" node-key="id"
							@check-change="handleCheckorange" :check-strictly="true">
							<span slot-scope="{ node, data }">
								<span v-if="data.treeLevel < 5" class="tree_folder">{{ data.name}}</span>
								<!-- 	<span v-else class="tree_file">
							{{ data.name}}</span> -->
							</span>
						</el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import {
		getVehicles
	} from '@/utils/auth'
	export default {
		name: "carlineBinding",
		data() {
			return {
				bindstate: false,
				checkedkeysobject: [],
				checkedtotal: 0,
				organProps: {
					children: 'children',
					label: 'label'
				},
				// defaultProps: {
				// 	children: 'children',
				// 	name: 'label'
				// },
				searchinput: "",
				organdata: [],
				data: [],
				selectdata: [],
				selectpid: 0,
				bindId: 0,
				fillist: [],
				newvehicletree: [],
				checkedtree: [], //选中的数组
				selectedNodesNum: 0
			}

		},
		computed: {
			...mapState({
				operator: state => state.user.operator,
			})
		},
		watch: {
			searchinput: {
				immediate: true,
				handler(newKeyword) {
					this.data = this.fillist.filter(item => item.name.includes(newKeyword));
					if (newKeyword == "") {
						this.getQuerycheckList();
					}
				}
			}
		},
		mounted() {
			this.getQuerycheckList();
			this.getoranlist();
			var vehicletree = getVehicles();
			if (vehicletree && vehicletree != "") {
				var newv = JSON.parse(vehicletree)
				this.fillist = newv;
			}
		},
		methods: {
			getQuerycheckList() {
				this.selectdata = [];
				var data = [];
				var vehicletree = getVehicles();
				if (vehicletree && vehicletree != "") {
					var newv = JSON.parse(vehicletree)
					this.data = newv;
					// console.log(newv)
					var result = this.loopVehicleTree(0, this.data);
					if (result) {
						data = result[0];
					}
					this.data = data;
				}
			},
			getoranlist() {
				var organdata = [];
				var vehicletree = getVehicles();
				var newv1 = JSON.parse(vehicletree)
				let organresult = newv1.filter(d => {
					return d.treeLevel < 5
				})
				// console.log(organresult)
				var result1 = this.loopVehicleTree(0, organresult);
				if (result1) {
					organdata = result1[0];
				}
				this.organdata = organdata;
			},

			calcTreeCount(node) {
				var online = 0;
				// var samelist = []
				if (node && node.children && node.children.length > 0)
					node.children.forEach(element => {
						online += this.calcTreeCount(element);
						if (element.treeLevel && element.treeLevel == 5) {
							if (this.checkedtree.length > 0) {
								this.checkedtree.forEach(item => {
									if (element.id == item.id) {
										online += 1;
									}
								})
							}
						}
					});
				// online = samelist.length;
				return online;

			},
			loopVehicleTree(pid, source) {
				var data = [];
				var online = 0;
				var total = 0;
				var rootNode = source.filter(r => {
					return r.pId == pid
				});

				if (rootNode && rootNode.length > 0) {
					rootNode.forEach(element => {
						element.onlineCount = 0;
						element.totalCount = 0;

						//计算在线数量和总数
						if (element.treeLevel && element.treeLevel == 5) {
							// if (element.isOnLine != 0)
							// element.onlineCount += 1;
							element.totalCount += 1;
						}

						var result = this.loopVehicleTree(element.id, source);
						if (result) {
							element.children = result[0];
							// element.onlineCount += result[1];
							element.totalCount += result[2];
						}
						// online += element.onlineCount
						total += element.totalCount
						data.push(element);
					});
				}
				return [data, online, total];
			},
			handleCheckChange(data, checked) {
				var result = [];
				if (checked) {
					this.checkedkeysobject[data.id] = data;
					// console.log(Object.values(this.checkedkeysobject));
					this.checkedtree = Object.values(this.checkedkeysobject);
					// console.log(this.checkedkeysobject);
					for (var i in this.checkedkeysobject) {
						result.push(this.checkedkeysobject[i].nodeValue);
					}
					this.selectdata = result;
					console.log(this.selectdata)
				} else {
					delete this.checkedkeysobject[data.id];
					this.checkedtree = Object.values(this.checkedkeysobject);
					console.log(this.checkedtree)
					for (var i in this.checkedkeysobject) {
						result.push(this.checkedkeysobject[i].nodeValue);
					}
					this.selectdata = result;
				}
			},
			handleCheckorange(data, checked, indeterminate) {
				if (checked) {
					this.$refs.dataTree.setCheckedKeys([data.id]);
					this.bindId = data.id;
					console.log(this.bindId);
				} else {
					// delete this.$refs.dataTree.setCheckedKeys[data.id];
					// this.bindId = 0;
				}
			},
			open3(message) {
				this.$message({
					message: message,
					type: 'warning'
				});
			},
			bindvehicle() {
				// const companyID = localStorage.getItem('companyId');
				this.bindstate = false;
				var newselectedvalue = this.selectdata.join(',')
				console.log(newselectedvalue)
				// console.log(newselectedvalue)
				if (newselectedvalue && this.bindId) {
					this.$api.bindRoute({
						companyID: this.operator.CompanyId,
						selectedvalue: newselectedvalue,
						bindvalue: this.bindId
					}).then((res) => {
						console.log(res);
						if (res && res.code == 200) {
							this.bindstate = true;
							this.searchinput = "";
							this.$store.dispatch('app/updateVehicleGroup', {
								vids: newselectedvalue,
								groupid: this.bindId
							});
							this.getQuerycheckList();
							this.getoranlist();
						} else {
							this.open3(this.$t('carlineBinding.bindfail'))
						}
					})
				} else if (this.selectdata.length <= 0) {
					this.open3(this.$t('carlineBinding.selectLeftvehicle'))
				} else if (this.bindId <= 0) {
					this.open3(this.$t('carlineBinding.selectGroup'))
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bindclass {
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.carlist {
		border: 1px solid #C5D0E2;
		border-radius: 4px;
		width: 360px;
		height: 520px;
		margin-bottom: 52px;
		margin-top: 21px;

	}

	.routeclass   {
		::v-deep .tree_folder {
			font-size: 12px;
			color: #0F1A3A;
			letter-spacing: 0;
			line-height: 12px;
			font-weight: bold;

		}
	}

	.routeclass {
		border: 1px solid #C5D0E2;
		border-radius: 4px;
		width: 360px;
		height: 520px;
		margin-bottom: 52px;
		margin-top: 21px;
	}

	.el-icon-success:before {
		color: #07B477;
	}

	.vehicle_tree {
		.tree_folder {
			font-size: 12px;
			color: #0F1A3A;
			letter-spacing: 0;
			line-height: 12px;
			font-weight: bold;

		}
	}

	.tree_file {
		font-size: 12px;
		color: #0F1A3A;
		letter-spacing: 0;
		line-height: 12px;

		.iconfont {
			color: #A2B1CB;
			margin-right: 8px;
		}
	}

	.is-checked span {
		color: #2A7AFF !important;
	}

	.is-checked i {
		color: #2A7AFF !important;
	}
</style>